import React from 'react';
import { getApiBase } from '../apiBase';

const LS_KEY = 'howto_taxes_remind';

export default function TaxesPanel({ ownerId, onClose }) {
  const [net, setNet] = React.useState(0);
  const [tax, setTax] = React.useState(null); // { setAside, perQuarter, ratePct } computed server-side
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');
  const [remind, setRemind] = React.useState(() => {
    try { return localStorage.getItem(LS_KEY) === '1'; } catch (_) { return false; }
  });

  const load = React.useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      // Server computes the set-aside from real completed-job net (one source of truth).
      const res = await fetch(`${getApiBase()}/api/company/tax-estimate?ownerId=${encodeURIComponent(ownerId)}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setNet(Number(data.net) || 0);
      setTax(data && data.ok ? data : null);
    } catch (_) {
      setError("Couldn't load your numbers. Try refresh.");
    } finally {
      setLoading(false);
    }
  }, [ownerId]);

  React.useEffect(() => { load(); }, [load]);

  React.useEffect(() => {
    try { localStorage.setItem(LS_KEY, remind ? '1' : '0'); } catch (_) {}
  }, [remind]);

  const setAside = tax ? Number(tax.setAside) || 0 : 0;
  const perQuarter = tax ? Number(tax.perQuarter) || 0 : 0;
  const ratePct = tax ? Number(tax.ratePct) || 30 : 30;
  const fmt = (n) => `$${Math.round(n).toLocaleString()}`;

  return (
    <div className="agent-detail" onClick={onClose}>
      <div className="agent-detail__panel" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="agent-detail__close" onClick={onClose} aria-label="Close">×</button>
        <div className="agent-detail__title">Quarterly taxes</div>
        <div className="agent-detail__cadence">Quarterly</div>
        <p className="agent-detail__desc">
          Updates your set-aside after every job, worst case so you're never short.
        </p>

        <div className="agent-detail__section">Your set-aside</div>
        {loading ? (
          <p className="sched-muted">Crunching your numbers…</p>
        ) : error ? (
          <div className="sched-warn">{error}</div>
        ) : net <= 0 ? (
          <div className="agent-detail__status">$0 — your set-aside grows as you complete jobs.</div>
        ) : (
          <div className="agent-detail__status">
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'rgba(255,255,255,0.96)' }}>
              {fmt(setAside)} set aside this year
            </div>
            <div className="sched-ok" style={{ marginTop: 6 }}>
              ≈ {fmt(perQuarter)} per quarter
            </div>
            <div className="sched-muted" style={{ marginTop: 6, fontSize: '0.85rem' }}>
              Based on {fmt(net)} net · {ratePct}% worst-case
            </div>
          </div>
        )}

        <label className="sched-toggle" style={{ marginTop: 14 }}>
          <input
            type="checkbox"
            checked={remind}
            onChange={(e) => setRemind(e.target.checked)}
          />
          <span>Remind me before each quarterly deadline</span>
        </label>

        <button type="button" className="sched-refresh" onClick={load} disabled={loading}>
          {loading ? 'Refreshing…' : 'Refresh'}
        </button>

        <div className="agent-detail__note">
          Worst-case estimate, not tax advice — confirm with your accountant.
        </div>
      </div>
    </div>
  );
}
